import { render, staticRenderFns } from "./PlanoContabil.vue?vue&type=template&id=0ac7e0dc&"
import script from "./PlanoContabil.vue?vue&type=script&lang=js&"
export * from "./PlanoContabil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports